// Data.js
const quizData = [
  {
    // 1
    question: "ถอดรหัสคำจากภาพด้านบน ❔",
    answer: "ส้มโอ",
    images: ["/images/โซ่.jpg", "/images/อม.jpg"],
    syllables: 2
  },
  {
    // 2
    question: "ถอดรหัสคำจากภาพด้านบน ❔",
    answer: "พระพิฆเนศ",
    images: ["/images/พระ.jpg", "/images/พริก.jpg", "/images/ตา.jpg"],
    syllables: 4
  },
  {
    // 3
    question: "ถอดรหัสคำจากภาพด้านบน ❔",
    answer: "ผลักดัน",
    images: ["/images/ผัก.jpg", "/images/ผลัก.jpg"],
    syllables: 2
  },
  {
    // 4
    question: "ผักชนิดนึง ❔",
    answer: "มะละกอ",
    images: ["/images/มะระ.jpg", "/images/ไก่.jpg", "/images/อ่าง.jpg"],
    syllables: 3
  },
  {
    // 5
    question: "สถานที่อะไรน้า ❔",
    answer: "พีระมิด",
    images: ["/images/p.jpg", "/images/ลา.jpg", "/images/มีด.jpg"],
    syllables: 3
  },
  {
    // 6
    question: "ถอดรหัสคำจากภาพด้านบน ❔",
    answer: "สวมรอย",
    images: ["/images/รอยเท้า.jpg", "/images/สวมเเหวน.jpg"],
    syllables: 2
  },
  {
    // 7
    question: "ถอดรหัสคำจากภาพด้านบน ❔",
    answer: "ประชาชน",
    images: ["/images/เส้นประ.jpg", "/images/ชา.jpg", "/images/ชน.jpg"],
    syllables: 3
  },
  {
    // 8
    question: "ถอดรหัสคำจากภาพด้านบน ❔",
    answer: "ฮอทดอก",
    images: ["/images/ร้อน.jpg", "/images/หมา.jpg"],
    syllables: 2
  },
  {
    // 9
    question: "ถอดรหัสคำจากภาพด้านบน ❔",
    answer: "ผ้าห่ม",
    images: ["/images/ผม.jpg", "/images/เลขห้า.jpg"],
    syllables: 2
  },
  {
    // 10
    question: "ถอดรหัสคำจากภาพด้านบน",
    answer: "ผลไม้",
    images: ["/images/ผึ้ง.jpg", "/images/ลิง.jpg", "/images/ไม้.jpg"],
    syllables: 3
  }
]

export default quizData
